import { useMemo } from 'react'

import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { useParentRequest } from 'onboarding/hooks/useParentRequest'
import { useRequest } from 'onboarding/hooks/useRequest'

import { contactValidateEmeaFields, partnerFields } from './configs'
import { ContractValidate } from './ContractValidate'
import { IContractValidateWidgetProps } from './models'

export const ContractValidateEmea = (props: IContractValidateWidgetProps) => {
  const { req } = useRequest(props.requestId || '')
  const { parentRequest } = useParentRequest(req.Parent)
  const request = useMemo(() => parentRequest ?? req, [req, parentRequest])

  return (
    <VisualAudienceExtended
      component={ContractValidate}
      write={props.audienceSettings}
      metrics={props.metrics}
      disabled={props.disabled}
      PartnerID={props.partnerID || request.PartnerId}
      partnerFields={partnerFields}
      contactFields={contactValidateEmeaFields}
      RequestId={request.EntryId?.toString()}
      flexWidth={props.flexWidth}
      appSource={props.appSource}
    />
  )
}
